import createReducer from '../reducer'

/**
 * The only caller of `store.replaceReducer`. Route data layers
 * (utils/asyncReducer.js) and the awareness-center wizard each own some keys
 * of one injected map; a swap rebuilds the root reducer from the whole map, so
 * one owner's change never drops another owner's slice (IC-52036).
 */
export const attachReducerRegistry = (store) => {
  const injected = {}
  const replace = () => store.replaceReducer(createReducer({ ...injected }))

  store.injectReducers = (reducers) => {
    const changed = Object.keys(reducers).filter((key) => injected[key] !== reducers[key])
    if (!changed.length) return
    changed.forEach((key) => {
      injected[key] = reducers[key]
    })
    replace()
  }

  store.removeReducers = (keys) => {
    const present = keys.filter((key) => key in injected)
    if (!present.length) return
    present.forEach((key) => {
      delete injected[key]
    })
    replace()
  }

  store.injectReducer = (key, reducer) => store.injectReducers({ [key]: reducer })
  store.removeReducer = (key) => store.removeReducers([key])

  return store
}
